import type React from 'react';

import { InfoIcon } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipTrigger } from '#src/app/shared/components/adminShadcn';

export const InfoTooltip: React.FC<React.PropsWithChildren> = ({ children }) => {
	return (
		<Tooltip>
			<TooltipTrigger
				type="button"
				aria-label="More information"
				className="admin:inline-flex admin:text-muted-foreground"
			>
				<InfoIcon className="admin:size-[18px]" />
			</TooltipTrigger>
			<TooltipContent className="admin:text-sm">{children}</TooltipContent>
		</Tooltip>
	);
};
